"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default() {
  return {
    content: "<strong>WE PROVIDE HIGH QUALITY PRODUCTS, GREAT SERVICE AND QUICK SHIPPING</strong>",
    collapsed: false,
    exportedHTML: ''
  };
}